import ThemeApi from '@/api/Theme'
import { defaultTheme } from '@/vuex/modules/ui/colorTheme/constants'
import { ThemeModel } from '@/models/Theme'

const assignModel = data => {
  return data.map(o => new ThemeModel(o))
}

const actions = {
  async INITIALIZE({ state, commit, dispatch }) {
    let theme
    // 現在のurlからdomainNameを取得
    const domainName = document.domain
    try {
      const ret = await dispatch('fetchTheme', { domainName })
      // テーマがないとき(ret.item === {} で比較したいが、vueの仕様上難しい)
      if (ret.item.id === undefined) throw new Error()
      theme = ret.item // テーマがあるとき
    } catch (e) {
      // テーマがないときにここに来る
      theme = defaultTheme
    }
    commit('SET_THEME', { theme })
  },
  async fetchTheme({ state }, { domainName }) {
    const ret = await ThemeApi.fetchTheme(domainName)
    return ret
  },
  async GET_ALL_THEME({ commit }) {
    const ret = await ThemeApi.fetchAllTheme()
    // todo ret.itemが単なるobjectとして来てるんで直ったら[]外す
    const modeledItems = assignModel(ret.items)
    commit('SET_THEME_LIST', modeledItems)
    return ret.item
  },
  async SAVE({ commit }, { form, systemOwnerId }) {
    const ret = ThemeModel.save(form, systemOwnerId)
    return ret
  },
}

export default actions
